export const environment = {
  production: true,
  baseHref: '/',
  dxtBaseHref: '/app/forms/mu1/',
  dxtOrigin: 'https://gateway.qa.finra.org',
  gatewayOrigin: 'https://gateway.qa.statemortgageregistry.com',
  dxtBasePath: '/app',
  formName: 'MU1 Form',
  env: 'qa',
  ags: 'MLSMOD',
  identityProviderRealm: 'isso' as 'ews' | 'isso',
  issoRoles: [],
  ewsRoles: [],
  activateBeast: false,
  mockHostApi: false,
  attachmentsTemplate: 'attachments-qa',
  identity: 'https://identity.qa.statemortgageregistry.com',
  logout: 'https://login.qa.statemortgageregistry.com/logout',
  urls: {
    datacollection: 'https://datacollection.qa.statemortgageregistry.com',
    entityProfileGraphql: 'https://entityprofile.qa.statemortgageregistry.com/profile',
    dataServicesGraphql: 'https://dataservices.qa.statemortgageregistry.com/api',
    dataServices: 'https://dataservices.qa.statemortgageregistry.com',
    individualSummary: 'https://gateway.qa.statemortgageregistry.com/app/entity-profile/individual-summary',
    cloudwell: 'https://csbsannualrenewalchecklist-dev.azurewebsites.net',
    csbsChecklist: 'https://csbsannualrenewalchecklist-dev.azurewebsites.net',
    fist: 'https://filestorage.qa.statemortgageregistry.com',
    apiReference: 'https://reference.qa.statemortgageregistry.com',
    mortgageLicensingSystem: 'https://qa.mortgage.nationwidelicensingsystem.org',
    origin: 'https://mu1-form.qa.statemortgageregistry.com',
    classicNmlsState: 'https://state-qa4.qa.statemortgageregistry.com',
  },
  defaultRoute: ['view', 'dataEntry', 'section', 'identifyingInformation'],
  currentVersion: '0.0.1',
  versions: {
    '0.0.1': {
      urls: {
        schema: 'https://mu1-form.qa.statemortgageregistry.com/assets/schemas/models/0.0.1/root.schema.json',
        schemasBase: 'https://mu1-form.qa.statemortgageregistry.com/assets/schemas/models/0.0.1',
        layoutsBase: 'https://mu1-form.qa.statemortgageregistry.com/assets/schemas/layouts/0.0.1',
        layoutTemplates: ['https://mu1-form.qa.statemortgageregistry.com/assets/schemas/layouts/0.0.1/layout-templates.json'],
        individualProfile: 'https://gateway.qa.statemortgageregistry.com/app/entity-profile/individual-profile',
        invoiceInfoUrl: 'https://state-qa4.qa.statemortgageregistry.com/Home/Invoice/InvoiceInfo.aspx?InvoiceId',
        workManagement: 'https://gateway.qa.statemortgageregistry.com/app/work-management',
        taskManagement: 'https://gateway.qa.statemortgageregistry.com/app/task-management',
      },
      template: {
        name: 'mu1-qa',
        namespace: 'nmls',
        version: '0.0.1',
      },
      extensions: {
        create: {
          name: 'create-mu1',
          version: '0.0.1',
          namespace: 'nmls',
        },
      },
    },
  },
};

export type Versions = keyof typeof environment.versions;
